export const open = () => {
  window.Beacon?.('open');
};
